import { getAccessToken } from '@/auth/authClient';

export const OSM_BASE = '/osm';
export const OSM_API = `${OSM_BASE}/api/v1`;

export class OsmHttpError extends Error {
  status: number;
  body: string;
  constructor(status: number, body: string, message?: string) {
    super(message ?? `HTTP ${status}`);
    this.status = status;
    this.body = body;
  }
}

function authHeaders(): Record<string, string> {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function osmGet<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`${OSM_API}${path}`, {
    method: 'GET',
    headers: { Accept: 'application/json', ...authHeaders(), ...(init?.headers ?? {}) },
    ...init,
  });
  if (!r.ok) {
    const body = await r.text().catch(() => '');
    throw new OsmHttpError(r.status, body);
  }
  return (await r.json()) as T;
}

export async function osmPost<T, B = unknown>(path: string, body: B, init?: RequestInit): Promise<T> {
  const r = await fetch(`${OSM_API}${path}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...(init?.headers ?? {}),
    },
    body: JSON.stringify(body),
    ...init,
  });
  if (!r.ok) {
    const text = await r.text().catch(() => '');
    throw new OsmHttpError(r.status, text);
  }
  return (await r.json()) as T;
}

export async function osmDelete(path: string): Promise<void> {
  const r = await fetch(`${OSM_API}${path}`, { method: 'DELETE', headers: authHeaders() });
  if (!r.ok && r.status !== 204) {
    const body = await r.text().catch(() => '');
    throw new OsmHttpError(r.status, body);
  }
}
